import React, { useState, useRef, useEffect } from "react";
import { DateRange } from "react-date-range";
import { enUS } from "date-fns/locale"; // ✅ Add this line
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import { mainTable } from "../css/Common";
import PropTypes from "prop-types";

const DateRangePicker = ({ onChange, selection, title, classStar,disable }) => {
  const [showPicker, setShowPicker] = useState(false);
  const pickerRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (pickerRef.current && !pickerRef.current.contains(event.target)) {
        setShowPicker(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div
      ref={pickerRef}
      style={{ position: "relative", display: "inline-block" }}
    >
      <label className={mainTable.label}>
        {title}
        <span className={classStar ? classStar : "hidden"}>*</span>
      </label>
      <button
        type="button"
        onClick={() => setShowPicker(!showPicker)}
        className={mainTable.input}
        disabled={disable}
      >
        {selection?.startDate && selection?.endDate
          ? `${selection.startDate.toLocaleDateString()} - ${selection.endDate.toLocaleDateString()}`
          : "Select a date range"}
      </button>

      {showPicker && (
        <div
          style={{
            position: "absolute",
            zIndex: 100,
            border: "1px solid #ccc",
            borderRadius: "8px",
            backgroundColor: "#fff",
            boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
            padding: "8px",
          }}
        >
          <DateRange
            editableDateInputs={true}
            onChange={(item) => onChange(item.selection)}
            moveRangeOnFirstSelection={false}
            ranges={[selection]}
            locale={enUS} // ✅ Pass the locale here
            disabledDates={disable}
          />
        </div>
      )}
    </div>
  );
};

DateRangePicker.propTypes = {
  onChange: PropTypes.func.isRequired,
  selection: PropTypes.object.isRequired,
  title: PropTypes.string.isRequired,
  classStar: PropTypes.string,
  disable:PropTypes.bool,
};

export default DateRangePicker;
